import { forEach } from '../helpers/pseudoPolyfills';
import { nodeListToArray } from '../helpers/pseudoPolyfills';

export const setTableCellsHeight = () => {
  if (window.innerWidth > 767) {
    const offerTables = document.querySelectorAll(".offer-table--origin .offer-table__offers");
    
    if(offerTables === 'undefined' || offerTables.length < 1) {
      return false;
    }
    
    offerTables.forEach(currentTable => {
      const tableRows = currentTable.querySelectorAll(".offers-item-row");

      tableRows.forEach(currentRow => {
        let tableRowItems = currentRow.querySelectorAll(".offer-item");
        let tempArray = [];
        forEach(tableRowItems, (i, elem) => {tempArray.push(elem)});
        tableRowItems = tempArray;
        tableRowItems = tableRowItems.filter((elem) => { return elem.parentNode.classList.contains('offers-item-row') });
        let currentRowHeight = getComputedStyle(currentRow).getPropertyValue("height");
        
        tableRowItems.forEach(currentItem => {
          currentItem.style.height = currentRowHeight;
        })
      })
    })
  }
}